/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { MarkupCommand } from './markup.command';
import { Dialog } from '@angular/cdk/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { OverlayPositionBuilder } from '@angular/cdk/overlay';
import { MediaObserver } from '@ngbracket/ngx-layout';

export function markupFactory() {
    const command = new MarkupCommand();
    command.setDependencies({
        dialog: inject(Dialog),
        bottomSheet: inject(MatBottomSheet),
        position: inject(OverlayPositionBuilder),
        media: inject(MediaObserver)
    });
    return command;
}
